<template>
    <div>
        <b-row>
            <b-col>
                <app-box titulo="Total a ser rateado">{{
                    valorASerRateado | currency
                }}</app-box>
            </b-col>
            <b-col>
                <app-box
                    titulo="Total rateado"
                    :corBox="cor"
                    :corTexto="cor"
                    >{{ valorRateado | currency }}
                    <!-- | {{
                        percentualRateado
                            | currency({
                                symbol: '%',
                                thousandsSeparator: '.',
                                fractionCount: 2,
                                fractionSeparator: ',',
                                symbolPosition: 'back',
                                symbolSpacing: false
                            })
                    }} -->
                </app-box>
            </b-col>
            <b-col>
                <app-box
                    titulo="Total disponível para ratear"
                    :corBox="cor"
                    :corTexto="cor"
                    >{{ valorDisponivel | currency }}</app-box
                >
            </b-col>
        </b-row>
        <app-tabela
            idTabela="tblRateios"
            :itens="rateios"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :mostrarFiltro="false"
            :bordered="false"
            :small="false"
        >
            <template slot="valor" slot-scope="data">{{
                data.valor | currency
            }}</template>
            <template slot="unidade" slot-scope="data"
                >({{ data.codUnidade }}) {{ data.nomeUnidade }}</template
            >
            <template slot="projeto" slot-scope="data"
                >({{ data.codProjeto }}) {{ data.nomeProjeto }}</template
            >
            <template slot="acao" slot-scope="data"
                >({{ data.codAcao }}) {{ data.nomeAcao }}</template
            >
            <template slot="botoes">
                <slot name="botoes"></slot>
            </template>
            <template slot="acoes" slot-scope="data">
                <btn-atualizar-dotacao
                    v-if="mostrandoTabelaAjustes"
                    :valorTotal="valorASerRateado"
                    :valorDisponivel="valorDisponivel"
                    :rateio="data"
                    @atualizarRateio="$emit('atualizarRateio', $event)"
                    @obterUnidades="$emit('obterUnidades')"
                    @obterProjetos="$emit('obterProjetos', $event)"
                    @obterAcoes="$emit('obterAcoes', $event)"
                    :unidades="unidades"
                    :projetos="projetos"
                    :acoes="acoes"
                ></btn-atualizar-dotacao>
                <btn-excluir-dotacao
                    v-if="mostrandoTabelaAjustes"
                    :rateio="data"
                    @excluirRateio="$emit('excluirRateio', data)"
                ></btn-excluir-dotacao>
                <slot name="acoes" v-bind="data"></slot>
            </template>
        </app-tabela>
    </div>
</template>

<script>
import BtnExcluirDotacao from './BtnExcluirDotacao'
import BtnAtualizarDotacao from './BtnAtualizarDotacao'

export default {
    components: {
        BtnAtualizarDotacao,
        BtnExcluirDotacao
    },

    props: {
        rateios: {
            type: Array
        },

        mostrandoTabelaAjustes: {
            type: Boolean
        },

        acao: {
            type: String
        },

        valorASerRateado: {
            type: Number,
            default: () => 0
        },

        valorRateado: {
            type: Number,
            default: () => 0
        },

        valorDisponivel: {
            type: Number,
            default: () => 0
        },

        unidades: {
            type: Array
        }, 

        projetos: {
            type: Array
        }, 
        
        acoes: {
            type: Array
        }
    },

    computed: {
        cor() {
            return this.valorRateado < this.valorASerRateado ? 'danger' : 'primary'
        },
    },

    data() {
        return {
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'unidade',
                    label: 'Unidade',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'projeto',
                    label: 'Projeto',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'acao',
                    label: 'Ação',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-nowrap text-right'
                }
            ],
            itensPorPagina: 0
        }
    },

}
</script>